<p-dialog
        [(visible)]="visible"
        [modal]="true"
        [header]="'Replace Content'"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '400px' }"
        (onHide)="closeDialog()"
>
    <div class="flex flex-col gap-6 my-3">
        <app-upload-media
                [useCase]="UploadUseCase.ReplaceMediaContent"
                [mediaId]="media.id"
                (uploadSuccess)="onUploadSuccess()"
        ></app-upload-media>

        <div class="flex justify-end gap-2 mt-10">
            <p-button
                    label="Cancel"
                    icon="pi pi-times"
                    class="p-button-text"
                    (click)="closeDialog()"
                    severity="secondary"
            ></p-button>
        </div>
    </div>
</p-dialog>
